import React from "react";
import { Provider } from "react-redux";
import { MemoryRouter as Router } from "react-router-dom";
import store from "redux/store";
import UCheck from "ucheck/ucheck.index";
import "utilities/styles/index.scss";
function App() {
  return (
    <Provider store={store}>
      <Router>
        <UCheck />
      </Router>
    </Provider>
  );
}

export default App;
